import { createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import { ax } from "src/common/api/apiClient";
import { IApi } from "src/common/typings/app";
import { IAddGateEntery } from "src/common/typings/vehicle";
import { VehicleState } from "../vehicleSlice";

// addGateEnteryAction 3 methods
export const handleAddGateEntery = (state: VehicleState, { payload }: PayloadAction<any>) => {
  state.status = "idle";
  state.vehicles.push(payload);
};
export const handleAddGateEnteryFail = (state: VehicleState) => {
  state.status = "failed";
};
export const addGateEnteryAction = createAsyncThunk(
  "vehicle/addGateEnteryAction", // this is type same like slice name

  async (entryData: IAddGateEntery, { dispatch }) => {
    try {
      const res = await ax.post<IApi>("/create-gate-entry", entryData);
      if (res.data.isSuccess === true) {
        return res.data.value.gateEntryId;
      } else {
        throw new Error(res.data.error || res.statusText);
      }
    } catch (error) {
      throw error;
    }
  }
);
// updateGatryAction 3 methods
export const handleUpdateGateEntery = (state: VehicleState, { payload }: PayloadAction<any>) => {
  state.status = "idle";
  state.vehicles.push(payload);
};
export const handleUpdateGateEnteryFail = (state: VehicleState) => {
  state.status = "failed";
};
export const updateGatryAction = createAsyncThunk(
  "vehicle/updateGateEnteryAction", // this is type same like slice name

  async (entryData: IAddGateEntery, { dispatch }) => {
    try {
      const res = await ax.post<IApi>("/update-gate-entry", entryData);
      if (res.data.isSuccess === true) {
        return res.data.value.gateEnteryId;
      } else {
        throw new Error(res.data.error || res.statusText);
      }
    } catch (error) {
      throw error;
    }
  }
);

// addMultiContainerGateEntryAction 3 methods
export const handleAddMultiContainerGateEntry = (
  state: VehicleState,
  { payload }: PayloadAction<any>
) => {
  state.status = "idle";
  state.vehicles.push(payload);
};
export const handleAddMultiContainerGateEntryFail = (state: VehicleState) => {
  state.status = "failed";
};
export const addMultiContainerGateEntryAction = createAsyncThunk(
  "vehicle/addMultiContainerGateEntryAction", // this is type same like slice name

  async (entryData: IAddGateEntery, { dispatch }) => {
    try {
      const res = await ax.post<IApi>("/create-gate-entry-nod", entryData);
      if (res.data.isSuccess === true) {
        return res.data.value.vehicleId;
      } else {
        throw new Error(res.data.error || res.statusText);
      }
    } catch (error) {
      throw error;
    }
  }
);

// updateMultiContainerGateEntryAction 3 methods
export const handleUpdateMultiContainerGateEntry = (
  state: VehicleState,
  { payload }: PayloadAction<any>
) => {
  state.status = "idle";
  state.vehicles.push(payload);
};
export const handleUpdateMultiContainerGateEntryFail = (state: VehicleState) => {
  state.status = "failed";
};
export const updateMultiContainerGateEntryAction = createAsyncThunk(
  "vehicle/updateMultiContainerGateEnteryAction", // this is type same like slice name

  async (entryData: IAddGateEntery, { dispatch }) => {
    try {
      const res = await ax.post<IApi>("/update-gate-entry-nod", entryData);
      if (res.data.isSuccess === true) {
        return res.data.value.gateEnteryId;
      } else {
        throw new Error(res.data.error || res.statusText);
      }
    } catch (error) {
      throw error;
    }
  }
);

/*Start File Upload Actions */
export const uploadDocument = createAsyncThunk(
  "workorder/uploadDocument",
  async (
    {
      url,
      fileRecord,
      contentType,
      size,
      fileCategoryId,
      gatePassId,
      fileComment,
    }: {
      url: string;
      fileRecord: File;
      contentType: string;
      size: number;
      fileCategoryId: any;
      gatePassId: any;
      fileComment: any;
    },
    { dispatch }
  ): Promise<boolean> => {
    const form = new FormData();
    form.append("File", fileRecord);
    form.append("fileCategoryId", fileCategoryId);
    form.append("gatePassId", gatePassId);
    form.append("comment", fileComment);
    // form.append("title", "test");
    try {
      const res = await ax.post<IApi>("/upload-gate-entry-doc", form, {
        headers: {},
      });
      if (res.data.isSuccess === true) {
        return true;
      } else {
        throw new Error(res.data.error || res.statusText);
      }
    } catch (error: any) {
      throw error;
    }
  }
);

/*Start File Upload Multi ContainerActions */
export const uploadDocumentMultiContainer = createAsyncThunk(
  "workorder/uploadDocumentMultiContainer",
  async (
    {
      url,
      fileRecord,
      contentType,
      size,
      fileCategoryId,
      vehicleId,
      fileComment,
    }: {
      url: string;
      fileRecord: File;
      contentType: string;
      size: number;
      fileCategoryId: any;
      vehicleId: any;
      fileComment: any;
    },
    { dispatch }
  ): Promise<boolean> => {
    const form = new FormData();
    form.append("File", fileRecord);
    form.append("fileCategoryId", fileCategoryId);
    form.append("vehicleId", vehicleId);
    form.append("comment", fileComment);
    // form.append("title", "test");
    try {
      const res = await ax.post<IApi>("/upload-gate-entry-doc-nod", form, {
        headers: {},
      });
      if (res.data.isSuccess === true) {
        return true;
      } else {
        throw new Error(res.data.error || res.statusText);
      }
    } catch (error: any) {
      throw error;
    }
  }
);

// Get Doc ID methods
export const handleGetAllGateDocsSuccess = (
  state: VehicleState,
  { payload }: PayloadAction<any>
) => {
  state.status = "idle";
  state.gatePassDocuments = payload;
};
export const handleGetAllGateDocsFail = (state: VehicleState) => {
  state.status = "failed";
};
export const getAllGateDocuments = createAsyncThunk(
  "gate-entry/get-documents",
  async ({ gatePassId }: { gatePassId: any }): Promise<any> => {
    try {
      const res = await ax.get<IApi>(`/get-all-gate-entry-docs-by-id/${gatePassId}`);
      if (res.data.isSuccess === true) return res.data.value.gateEntryDocList;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
// END Get Doc ID methods

// Get Doc Multi Container ID methods
export const handleGetAllMultiContainerGateDocsSuccess = (
  state: VehicleState,
  { payload }: PayloadAction<any>
) => {
  state.status = "idle";
  state.gatePassDocuments = payload;
};
export const handleGetAllMultiContainerGateDocsFail = (state: VehicleState) => {
  state.status = "failed";
};
export const getAllMultiContainerGateDocuments = createAsyncThunk(
  "gate-entry/get-multi-container-documents",
  async ({ gatePassId }: { gatePassId: any }): Promise<any> => {
    try {
      const res = await ax.get<IApi>(
        `/get-all-gate-entry-docs-by-id/${gatePassId}?IsNodRequest=true`
      );
      if (res.data.isSuccess === true) return res.data.value.gateEntryDocList;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
// END Get Multi Container Doc ID methods

// Create Vehicle Inspection methods
export const createVehicleInspectionScanner = createAsyncThunk(
  "vehicle/create-inspection-scanner",
  async (data: FormData, { dispatch }) => {
    try {
      const res = await ax.post<IApi>("/create-vehicle-inspection-scanner", data, {
        headers: {
          "content-type": "Application/json",
        },
      });
      if (res.data.isSuccess === true && res.data.value.isCreated === true) {
        return res.data.value;
      } else if (res.data.isSuccess === true && res.data.value.isScanAlreadyExist === true) {
        return res.data.value;
      }
      // else if (res.data.value.isCreated === false) {
      //   dispatch(
      //     addNotificationAction({
      //       message: "Something went wrong!",
      //       options: { variant: "error" },
      //     })
      //   );
      // }
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
// END Create Vehicle Inspection methods

// Create Vehicle Inspection methods
export const updateVehicleInspectionScanner = createAsyncThunk(
  "vehicle/update-inspection-scanner",
  async (data: FormData, { dispatch }) => {
    try {
      const res = await ax.post<IApi>("/update-vehicle-inspection-scanner", data, {
        headers: {
          "content-type": "Application/json",
        },
      });
      if (res.data.isSuccess === true && res.data.value.isCreated === true) {
        return res.data.value.isCreated;
      } else if (res.data.value.isCreated === false) {
        dispatch(
          addNotificationAction({
            message: "Something went wrong!",
            options: { variant: "error" },
          })
        );
      } else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
// END Create Vehicle Inspection methods

// Delete Vehicle Inspection methods
export const deleteVehicleInspectionScanner = createAsyncThunk(
  "vehicle/delete-inspection-scanner",
  async (item: any): Promise<any> => {
    try {
      const res = await ax.delete<IApi>(
        `/delete-vehicle-inspection-scanner/${item.vehicleScanId}?serialNo=${item.serialNumber}&regNo=${item.registrationNumber}&gatePassId=${item.gatePassId}&remarks=${item.deleteRemarks}`
      );
      if (res.data.isSuccess === true) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
// END Delete Vehicle Inspection methods

// Delete Vehicle Inspection methods
export const deleteVehicleInspectionWeight = createAsyncThunk(
  "vehicle/delete-inspection-weight",
  async (item: any): Promise<any> => {
    try {
      const res = await ax.delete<IApi>(
        `/delete-vehicle-weight/${item.vehicleWeightId}?serialNo=${item.serialNumber}&regNo=${item.registrationNumber}&gatePassId=${item.gatePassId}&remarks=${item.deleteRemarks}`
      );
      if (res.data.isSuccess === true) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const deleteNodVehicleInspectionWeight = createAsyncThunk(
  "vehicle/delete-nod-inspection-weight",
  async (item: any): Promise<any> => {
    try {
      const res = await ax.delete<IApi>(
        `/delete-nod-vehicle-weight/${item.deleteGridItem}?remarks=${item.deleteRemarks}`
      );
      if (res.data.isSuccess === true) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
// END Delete Vehicle Inspection methods

// Upload Vehicle Inspection Scan Docs methods
export const uploadVehicleScanDocs = createAsyncThunk(
  "vehicle/upload-vehicle-scan-doc",
  async (data: FormData, { dispatch }) => {
    try {
      const res = await ax.post<IApi>("/upload-vehicle-scan-doc", data, {
        headers: {
          "content-type": "Application/json",
        },
      });
      if (res.data.isSuccess === true && res.data.value.isFilesCreated === true) {
        return res.data.value.isFilesCreated;
      } else if (res.data.value.isFilesCreated === false) {
        dispatch(
          addNotificationAction({
            message: "Something went wrong!",
            options: { variant: "error" },
          })
        );
      } else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
// END Upload Vehicle Inspection Scan Docs methods

export const getWeightScanExistingDocuments = createAsyncThunk(
  "gate-entry/getWeightScanExistingDocuments",
  async (data: any): Promise<any> => {
    try {
      const res = await ax.get<IApi>(
        `/get-file-thumbnails-by-id/${data.id}?isNodWeightFile=${data.isNodWeightFile}&isScanFiles=${data.isScan}`
      );
      if (res.data.isSuccess === true) return res.data.value.fileThumbnails;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

// Get previous gate entry docs
export const getPreviousGateEntryDocs = createAsyncThunk(
  "gate-entry/getPreviousGateEntryDocs",
  async (regNum: string): Promise<any> => {
    try {
      const res = await ax.get<IApi>(`/get-all-previous-gate-entry-docs-by-reg-num/${regNum}`);
      if (res.data.isSuccess === true) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
// End get previous gate entry docs

// Upload Vehicle Inspection Scan Docs methods
export const createPreviousGateEntryDocs = createAsyncThunk(
  "vehicle/create-previous-gate-entry-docs",
  async (data: any, { dispatch }) => {
    try {
      const res = await ax.post<IApi>("/create-previous-gate-entry-docs", data, {
        headers: {
          "content-type": "Application/json",
        },
      });
      if (res.data.isSuccess === true && res.data.value.isCreated === true) {
        return res.data.value.isCreated;
      } else if (res.data.value.isCreated === false) {
        dispatch(
          addNotificationAction({
            message: "Something went wrong!",
            options: { variant: "error" },
          })
        );
      } else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
// END Upload Vehicle Inspection Scan Docs methods

// Create Vehicle Inspection Weight methods
export const createVehicleInspectionWeight = createAsyncThunk(
  "vehicle/create-inspection-weight",
  async (data: FormData, { dispatch }) => {
    try {
      const res = await ax.post<IApi>("/create-vehicle-weight", data, {
        headers: {
          "content-type": "Application/json",
        },
      });
      if (res.data.isSuccess === true && res.data.value.isCreated === true) {
        return res.data.value;
      } else if (res.data.isSuccess === true && res.data.value.isWeightAlreadyExist === true) {
        return res.data.value;
      }
      // else if (res.data.value.isCreated === false) {
      //   dispatch(
      //     addNotificationAction({
      //       message: "Something went wrong!",
      //       options: { variant: "error" },
      //     })
      //   );
      // }
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

// Create Vehicle Inspection Weight methods
export const updateVehicleInspectionWeight = createAsyncThunk(
  "vehicle/update-inspection-weight",
  async (data: FormData, { dispatch }) => {
    try {
      const res = await ax.post<IApi>("/update-vehicle-weight", data, {
        headers: {
          "content-type": "Application/json",
        },
      });
      if (res.data.isSuccess === true && res.data.value.isCreated === true) {
        return res.data.value.isCreated;
      } else if (res.data.value.isCreated === false) {
        dispatch(
          addNotificationAction({
            message: "Something went wrong!",
            options: { variant: "error" },
          })
        );
      } else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

// Upload Vehicle Inspection Weight Docs methods
export const uploadVehicleWeightDocs = createAsyncThunk(
  "vehicle/upload-vehicle-weight-doc",
  async (data: FormData, { dispatch }) => {
    try {
      const res = await ax.post<IApi>("/upload-vehicle-weight-doc", data, {
        headers: {
          "content-type": "Application/json",
        },
      });
      if (res.data.isSuccess === true && res.data.value.isFilesCreated === true) {
        return res.data.value.isFilesCreated;
      } else if (res.data.value.isFilesCreated === false) {
        dispatch(
          addNotificationAction({
            message: "Something went wrong!",
            options: { variant: "error" },
          })
        );
      } else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
// END Upload Vehicle Inspection Weight Docs methods

export const getLocationAtTerminal = createAsyncThunk(
  "gate-entry/getLocationAtTerminal",
  async (): Promise<any> => {
    try {
      const res = await ax.get<IApi>("/get-all-terminal-locations?isActive=true");
      if (res.data.isSuccess === true) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const getSecondaryInspectionDepartments = createAsyncThunk(
  "gate-entry/getSecondaryInspectionDepartments",
  async (): Promise<any> => {
    try {
      const res = await ax.get<IApi>("/get-all-terminal-locations?showDepartments=true");
      if (res.data.isSuccess === true) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
// END Create Vehicle Inspection Weight methods

export const getVehicleDetailsByIdAction = createAsyncThunk(
  "configuration/getVehicleDetailsByIdAction", // action string
  async (id: number) => {
    try {
      const res = await ax.get<IApi>(`/get-gate-entry-vehicle-detail-by-id/${id}`);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const getNodVehicleDetailsByIdAction = createAsyncThunk(
  "configuration/getNodVehicleDetailsByIdAction", // action string
  async (id: number) => {
    try {
      const res = await ax.get<IApi>(`/get-vehicle-detail-by-id/${id}`);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getPictureGalleryContentById = createAsyncThunk(
  "configuration/getPictureGalleryContentById", // action string
  async (gatePassId: number) => {
    try {
      const res = await ax.get<IApi>(`/get-doc-by-gate-pass-id/${gatePassId}`);
      return res;
    } catch (error) {
      throw error;
    }
  }
);

export const validateVehicleGatePassEditRequest = createAsyncThunk(
  "configuration/validateVehicleGatePassEditRequest", // action string
  async (data: any) => {
    try {
      const res = await ax.post<IApi>("/validate-gate-pass-edit-request", data);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const markVehicleEntryAsReview = createAsyncThunk(
  "configuration/markVehicleEntryAsReview", // action string
  async (data: any) => {
    try {
      const res = await ax.post<IApi>("/gate-pass-pending-review", data);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const markVehicleEntryAsWrong = createAsyncThunk(
  "vehicle/markVehicleEntryAsWrong", // action string
  async ({ gatePassId, remarks }: any): Promise<any> => {
    try {
      const res = await ax.delete<IApi>(`/delete-gate-entry/${gatePassId}?remarks=${remarks}`);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const markVehicleEntryAsReject = createAsyncThunk(
  "vehicle/markVehicleEntryAsReject", // action string
  async (data: any): Promise<any> => {
    try {
      const res = await ax.post<IApi>("/gate-pass-reject-pending-review-vehicle", data);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
